module.exports = __webpack_public_path__ + "static/media/kirigaya-suguha-win.72d8c84a.png";